import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const BarChartComponent = ({ data }) => {
  const formattedData = data.map(item => ({
    name: item.name,
    'ADHD Fit %': item.adhd_fit,
    'Rating (x20)': item.rating * 20
  }));

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const originalData = data.find(d => d.name === label);
      return (
        <div className="bg-[#1e1e26] border border-[#22222e] rounded-lg px-4 py-3">
          <p className="text-white font-bold mb-2" style={{ fontFamily: 'DM Mono, monospace' }}>{label}</p>
          <p className="text-[#ff4500] text-sm" style={{ fontFamily: 'DM Mono, monospace' }}>ADHD Fit: {originalData.adhd_fit}%</p>
          <p className="text-[#38bdf8] text-sm" style={{ fontFamily: 'DM Mono, monospace' }}>Rating: {originalData.rating}/5.0</p>
          <p className="text-[#7b7a88] text-sm" style={{ fontFamily: 'DM Mono, monospace' }}>Price: {originalData.price}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={formattedData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#22222e" />
        <XAxis 
          dataKey="name" 
          stroke="#7b7a88" 
          style={{ fontFamily: 'DM Mono, monospace', fontSize: '11px' }}
        />
        <YAxis 
          stroke="#7b7a88" 
          style={{ fontFamily: 'DM Mono, monospace', fontSize: '12px' }}
        />
        <Tooltip content={<CustomTooltip />} />
        <Legend 
          wrapperStyle={{ fontFamily: 'DM Mono, monospace', fontSize: '12px' }}
        />
        <Bar 
          dataKey="ADHD Fit %" 
          fill="#ff4500" 
          radius={[4, 4, 0, 0]}
        />
        <Bar 
          dataKey="Rating (x20)" 
          fill="#38bdf8" 
          radius={[4, 4, 0, 0]}
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default BarChartComponent;
